"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListFilesImpulse = void 0;
var ListFilesImpulse = /** @class */ (function () {
    function ListFilesImpulse(uri) {
        this.uri = uri;
    }
    return ListFilesImpulse;
}());
exports.ListFilesImpulse = ListFilesImpulse;
//# sourceMappingURL=ListFilesImpulse.js.map